/* eslint-disable no-unused-vars */
import { useParams } from "react-router-dom";
import PageHeader from "../../../../components/PageHeader";
import {
  Button,
  Table,
  Typography,
  Menu,
  Space,
  Dropdown,
  message,
  Select,
  Modal,
  notification,
  Spin,
  Radio,
  Tag,
} from "antd";
import { useEffect, useState } from "react";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import { useDispatch, useSelector } from "react-redux";
import { actions, reducer, sliceKey } from "./slice";
import { reviewReportSaga } from "./saga";
import * as selectors from "./selectors";
import { MoreOutlined } from "@ant-design/icons";
import "./style.css";
import Text from "antd/lib/typography/Text";
import ResultCell from "./components/ResultCell";
import ReportedParameterCell from "./components/ReportedParameterCell";
import { useAuth } from "../../../../contexts/auth";
import RaiseCorrectionRequest from "../../../../components/RaiseCorrectionRequest";
import ViewCorrection from "../../../../components/ViewCorrection";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

export default function ReviewReport() {
  const location = useLocation();
  const _id = location.state?._id;

  const auth = useAuth();
  const user = auth.loggedInUser;
  const userRole = user?.role;

  useInjectReducer({ key: sliceKey, reducer });
  useInjectSaga({ key: sliceKey, saga: reviewReportSaga });
  const dispatch = useDispatch();
  const { id } = useParams();
  const data = useSelector(selectors.selectData) || {};
  const reportUrl = useSelector(selectors.selectReportUrl);
  const isLoading = useSelector(selectors.selectIsReviewReportPageLoading);
  const [changedData, setChangedData] = useState({});

  const [showPdf, setShowPdf] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState({
    title: "",
    data: [],
    errData: null,
  });
  const [unSaveAction, setUnSaveAction] = useState("");
  const { Paragraph } = Typography;
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [tableData, setTableData] = useState([]);
  const [mismatchedParameters, setMissmatchedParameters] = useState([]);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [isSaveLoading, setIsSaveLoading] = useState(false);
  const [isActionModalVisible, setIsActionModalVisible] = useState(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState(false);
  const [actionType, setActionType] = useState("");
  const [actionData, setActionData] = useState({});
  const [filters, setFilters] = useState({});

  const [openRaiseCorrectionModal, setOpenRaiseCorrectionModal] =
    useState(false);
  const [openViewCorrectionModal, setOpenViewCorrectionModal] = useState(false);

  const handleDataChange = (value, record, attribute, isManuallyMatched) => {
    if (!value && value !== 0) return;
    if (
      attribute === "parameterValue" &&
      (value >= parseFloat(record.maxAllowedValue) ||
        value < parseFloat(record.minAllowedValue))
    ) {
      message.error(
        `Entered value is not acceptable as per FSSAI limits. Acceptable range ${record.minAllowedValue} to ${record.maxAllowedValue}`
      );
      return;
    }

    if (attribute === "reportedParameter") {
      const newData = mismatchedParameters.find(
        (param) => param.reportedParameter === value
      );

      const newRecord = {
        ...record,
        reportedParameter: value,
        parsedValue: newData?.parsedValue || null,
        parameterValue: isManuallyMatched
          ? record.parameterValue
          : newData?.parameterValue || newData?.parameterValue === 0
          ? newData?.parameterValue
          : null,
        compliance: null,
        status:
          isManuallyMatched && record?.parameterValue
            ? "manually matched"
            : record?.parameterValue ||
              newData?.parameterValue ||
              newData?.parameterValue === 0
            ? "matched"
            : record.status,
        manuallyMatched: isManuallyMatched,
      };

      setTableData((prevData) =>
        prevData.map((item) => (item.id === record.id ? newRecord : item))
      );
      setChangedData((prevState) => ({
        ...prevState,
        [record.id]: newRecord,
      }));
      setMissmatchedParameters((prevParams) =>
        prevParams.filter((param) => param.reportedParameter !== value)
      );
    } else if (attribute === "parameterValue") {
      setTableData((prevData) =>
        prevData.map((item) =>
          item.id === record.id
            ? {
                ...item,
                [attribute]: value,
                compliance: null,
                status:
                  record?.reportedParameter &&
                  (record?.manuallyMatched || isManuallyMatched)
                    ? "manually matched"
                    : record?.reportedParameter
                    ? "matched"
                    : record.status,
              }
            : item
        )
      );
      setChangedData((prevState) => ({
        ...prevState,
        [record.id]: {
          ...record,
          [attribute]: value,
          compliance: null,
          status:
            record?.reportedParameter &&
            (record?.manuallyMatched || isManuallyMatched)
              ? "manually matched"
              : record?.reportedParameter
              ? "matched"
              : record.status,
        },
      }));
    }
  };

  const handleSave = () => {
    const updatedData = Object.values(changedData);
    if (updatedData?.length === 0) {
      message.warning("No changes made to save & Re-Evaluate.");
      return;
    }
    setIsSaveLoading(true);
    dispatch(
      actions.saveChangedData({
        data: {
          orderId: id,
          commodity: data?.commodity,
          sampleVariant: data?.sampleVariant,
          reviewStatus: data?.reviewStatus,
          orderData: updatedData,
        },
        onSuccess: (data) => {
          const openModal = () => {
            setModalContent({
              title: "Update Successful",
              data: data?.orderData || [],
              errData: null,
            });
            setModalVisible(true);
          };
          notification.success({
            message: "Changes saved successfully!",
            description: (
              <span
                style={{ color: "#1890ff", cursor: "pointer" }}
                onClick={openModal}
              >
                Click here for more details
              </span>
            ),
            duration: 15,
            placement: "bottomLeft",
          });
          setIsSaveLoading(false);
          if (unSaveAction === "save") {
            handleConfirmAction();
          } else {
            setChangedData({});
            getReportdata();
          }
        },
        onFailure: (error) => {
          notification.error({
            message: "Failed to save changes.",
            duration: 0,
            placement: "bottomLeft",
          });
          setIsSaveLoading(false);
          setChangedData({});
        },
      })
    );
  };

  const handleSubmit = () => {
    if (data?.parametersOverview?.missingParameters !== 0) {
      message.warning("Please resolve all missing parameters to Complete.");
      return;
    }
    setIsSubmitLoading(true);
    dispatch(
      actions.submitReportData({
        orderId: id,
        onSuccess: () => {
          notification.success({
            message: "Report submitted successfully!",
            placement: "bottomLeft",
          });
          setIsSubmitLoading(false);
        },
        onFailure: () => {
          notification.error({
            message: "Failed to submit report.",
            placement: "bottomLeft",
          });
          setIsSubmitLoading(false);
        },
      })
    );
  };

  const getMenuItems = (record) => {
    const isDisabled = record.status === "not tested";
    return (
      <Menu>
        <Menu.Item
          key="notTested"
          onClick={() => {
            setActionData(record);
            setActionType("notTested");
            setUnSaveAction("save");
            setIsActionModalVisible(true);
          }}
          disabled={isDisabled}
          title={isDisabled ? "Already In Not Tested" : undefined}
        >
          Mark as Not Tested
        </Menu.Item>
        <Menu.Item
          key="removeMapping"
          onClick={() => {
            setActionData(record);
            setActionType("removeMapping");
            setUnSaveAction("save");
            setIsActionModalVisible(true);
          }}
          disabled={isDisabled || record.status === "missing"}
          title={
            record.status === "missing"
              ? "Already missing"
              : isDisabled
              ? "This item marked as Not Tested"
              : undefined
          }
        >
          Remove Mapping
        </Menu.Item>
      </Menu>
    );
  };

  const getParameterOptions = () => {
    const parameterOptions = [];
    mismatchedParameters.forEach((param) => {
      parameterOptions.push({
        text: param.reportedParameter,
        value: param.reportedParameter,
      });
    });
    return parameterOptions;
  };

  const columns = [
    {
      title: "S. No.",
      dataIndex: "id",
      width: "5%",
    },
    {
      title: "FoodLabz Parameter",
      dataIndex: "labxParameter",
      width: "12%",
    },
    {
      title: "Reported Parameter",
      dataIndex: "reportedParameter",
      width: "12%",
      render: (_, record) => {
        return (
          <ReportedParameterCell
            record={record}
            handleDataChange={handleDataChange}
            getParameterOptions={getParameterOptions}
          />
        );
      },
    },
    {
      title: "Parameter Type",
      dataIndex: "parameterType",
      width: "8%",
    },
    {
      title: "Test Type",
      dataIndex: "testType",
      width: "8%",
    },
    {
      title: "Parsed Value",
      dataIndex: "parsedValue",
      width: "8%",
    },
    {
      title: "Result",
      dataIndex: "result",
      width: "25%",
      render: (_, record) => (
        <ResultCell record={record} handleDataChange={handleDataChange} />
      ),
    },
    {
      title: "Required Units",
      dataIndex: "unit",
      width: "8%",
    },
    {
      title: "FSSR Limit",
      dataIndex: "fssrLimit",
      width: "10%",
    },
    {
      title: "Compliance",
      dataIndex: "compliance",
      width: "10%",
      filterSearch: true,
      filters: [
        {
          text: "Safe",
          value: "safe",
        },
        {
          text: "UnSafe",
          value: "unsafe",
        },
        {
          text: "Sub-standard",
          value: "sub-standard",
        },
        {
          text: "Standard",
          value: "standard",
        },
      ],
      filteredValue: filters.compliance || null,
    },
    {
      title: "Status",
      dataIndex: "status",
      width: "10%",
      filterSearch: true,
      filters: [
        {
          text: "Matched",
          value: "matched",
        },
        { text: "Manually Matched", value: "manually matched" },
        {
          text: "missing",
          value: "missing",
        },
        {
          text: "Not Tested",
          value: "not tested",
        },
      ],
      filteredValue: filters.status || null,
      render: (text) => (
        <span
          style={{
            color: text?.toLowerCase() === "missing" ? "red" : "inherit",
          }}
        >
          {text}
        </span>
      ),
    },
    ...(userRole === "lab_admin" || userRole === "support_team"|| userRole === "csc_admin"
      ? []
      : [
          {
            title: "Action",
            render: (_, record) => (
              <Space size="middle">
                <Dropdown overlay={getMenuItems(record)}>
                  <Button type="text" shape="circle" icon={<MoreOutlined />} />
                </Dropdown>
              </Space>
            ),
            width: "10%",
          },
        ]),
  ];

  const modalColumn = [
    {
      title: "FoodLabz Parameter",
      dataIndex: "labxParameter",
      key: "labxParameter",
    },
    {
      title: "Compliance",
      dataIndex: "compliance",
      key: "compliance",
      render: (_, record) => (
        <span>{record.compliance ? record.compliance : "--"}</span>
      ),
    },
    {
      title: "value",
      dataIndex: "parameterValue",
      key: "parameterValue",
      render: (_, record) => (
        <span>{record.parameterValue ? record.parameterValue : "--"}</span>
      ),
    },
  ];

  const handleTablePagination = (pagination, filters) => {
    const newPage = pagination?.current;
    const newPageSize = pagination?.pageSize;
    setFilters(filters);

    if (newPage !== currentPage) {
      setCurrentPage(newPage);
    }
    setPageSize(newPageSize);

    const queryParams = new URLSearchParams();
    queryParams.append("page", newPage);
    queryParams.append("page_size", newPageSize);

    if (filters.compliance) {
      filters.compliance.forEach((cat) =>
        queryParams.append("compliance", cat)
      );
    }
    if (filters.status) {
      filters.status.forEach((el) => queryParams.append("status", el));
    }

    const query = queryParams.toString();

    dispatch(actions.fetchReportData({ id, query }));
  };

  const getReportdata = () => {
    const queryParams = new URLSearchParams();
    queryParams.append("page", currentPage);
    queryParams.append("page_size", pageSize);

    if (filters.compliance) {
      filters.compliance.forEach((cat) =>
        queryParams.append("compliance", cat)
      );
    }
    if (filters.status) {
      filters.status.forEach((el) => queryParams.append("status", el));
    }

    const query = queryParams.toString();
    dispatch(actions.fetchReportData({ id, query }));
  };

  const handleConfirmAction = () => {
    const action = actionType === "notTested" ? "not tested" : "missing";
    setIsConfirmLoading(true);
    dispatch(
      actions.reviewReportAction({
        action,
        data: {
          orderId: id,
          commodity: data?.commodity,
          sampleVariant: data?.sampleVariant,
          orderData: [actionData],
        },
        onSuccess: () => {
          notification.success({
            message: `${
              actionType === "notTested"
                ? "Marked as Not Tested"
                : "Removed Mapping"
            } successfully!`,
            placement: "bottomLeft",
          });
          setIsActionModalVisible(false);
          setIsConfirmLoading(false);
          setActionType("");
          setActionData({});
          getReportdata();
          setChangedData({});
          setUnSaveAction("");
        },
        onFailure: (error) => {
          notification.error({
            message: `Failed to ${
              actionType === "notTested"
                ? "Marked as Not Tested"
                : "Removed Mapping"
            }`,
          });
          setIsConfirmLoading(false);
        },
      })
    );
  };

  useEffect(() => {
    dispatch(actions.fetchReportData({ id, query: "page=1&page_size=10" }));
    dispatch(actions.fetchReportSasUrl({ id }));
  }, [dispatch, id]);

  useEffect(() => {
    if (data?.orderData) {
      setTableData(data.orderData);
    }
    if (data?.mismatched) {
      setMissmatchedParameters(data.mismatched);
    }
  }, [data?.orderData, data?.mismatched]);

  let actionButtons = [
    <Button onClick={() => setShowPdf(!showPdf)}>
      {showPdf ? "Hide Pdf" : "Show Pdf"}
    </Button>,
    <Button type="primary" onClick={() => setOpenViewCorrectionModal(true)}>
      View Correction Request
    </Button>,
  ];

  if (
    !(
      data?.reviewStatus === "ReviewCompleted" ||
      userRole === "lab_admin" ||
      userRole === "support_team" || userRole === "csc_admin"
    )
  ) {
    actionButtons = [
      ...actionButtons,
      <Button
        type="primary"
        style={{
          backgroundColor: "#e97e3a",
          borderColor: "#e97e3a",
        }}
        onClick={() => setOpenRaiseCorrectionModal(true)}
      >
        Raise Correction
      </Button>,
      <Button
        key="reevaluate"
        type="secondary"
        onClick={handleSave}
        loading={isSaveLoading}
      >
        Save & Re-Evaluate
      </Button>,
      <Button
        key="back"
        type="primary"
        onClick={handleSubmit}
        loading={isSubmitLoading}
      >
        Submit
      </Button>,
    ];
  }

  return (
    <div>
      <Modal
        title={modalContent?.title}
        visible={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={[
          <Button
            key="close"
            type="primary"
            onClick={() => setModalVisible(false)}
          >
            Close
          </Button>,
        ]}
        modalRender={(modal) => (
          <div style={{ borderRadius: 8, overflow: "hidden" }}>{modal}</div>
        )}
      >
        {modalContent?.data?.length ? (
          <Table
            dataSource={modalContent?.data}
            rowKey="id"
            pagination={false}
            columns={modalColumn}
            size="middle"
            bordered
            scroll={{ x: true }}
          />
        ) : (
          <div style={{ textAlign: "center", color: "#888" }}>
            No data available
          </div>
        )}
      </Modal>
      {isLoading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: 50,
            height: "60vh",
          }}
        >
          <Spin size="large" />
        </div>
      ) : data?.sampleComplianceDetails && data?.parametersOverview ? (
        <>
          <PageHeader actions={actionButtons} />

          <div
            style={{
              background: "#fff",
              borderRadius: 8,
              padding: 24,
              boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
              margin: "16px 0",
            }}
          >
            <Space align="start">
              <p
                style={{
                  color: "#131A12",
                  fontSize: "20px",
                  fontWeight: "600",
                  marginBottom: "8px",
                }}
              >
                Order Details
              </p>
              <Tag
                color={statusColorMap[data.reviewStatus] || "default"}
                style={{
                  fontWeight: 600,
                  fontSize: 14,
                  padding: "2px 8px",
                  borderRadius: "6px",
                }}
              >
                {data.reviewStatus}
              </Tag>
            </Space>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div
                style={{
                  flex: 1.5,
                  display: "flex",
                  flexDirection: "column",
                  width: "50%",
                }}
              >
                <p
                  style={{
                    color: "#6C757D",
                    fontSize: "14px",
                    fontWeight: "500",
                    margin: 0,
                  }}
                >
                  Order Id
                </p>{" "}
                <p
                  style={{
                    color: "#131A12",
                    fontSize: "16px",
                    fontWeight: "600",
                    margin: 0,
                  }}
                >
                  {data.orderId}
                </p>
                <p
                  style={{
                    color: "#6C757D",
                    fontSize: "14px",
                    fontWeight: "500",
                    margin: 0,
                  }}
                >
                  Reported
                </p>{" "}
                <p
                  style={{
                    color: "#313CA8",
                    fontSize: "16px",
                    fontWeight: "600",
                    margin: 0,
                  }}
                >
                  {data.OrderIDReport}
                </p>
              </div>
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  width: "50%",
                }}
              >
                <p
                  style={{
                    color: "#6C757D",
                    fontSize: "14px",
                    fontWeight: "500",
                    margin: 0,
                  }}
                >
                  Commodity
                </p>{" "}
                <p
                  style={{
                    color: "#131A12",
                    fontSize: "16px",
                    fontWeight: "600",
                    margin: 0,
                  }}
                >
                  {data.commodity}
                </p>
                <p
                  style={{
                    color: "#6C757D",
                    fontSize: "14px",
                    fontWeight: "500",
                    margin: 0,
                  }}
                >
                  Reported
                </p>{" "}
                <p
                  style={{
                    color: "#313CA8",
                    fontSize: "16px",
                    fontWeight: "600",
                    margin: 0,
                  }}
                >
                  {data.commodityReport}
                </p>
              </div>
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  width: "50%",
                }}
              >
                <p
                  style={{
                    color: "#6C757D",
                    fontSize: "14px",
                    fontWeight: "500",
                    margin: 0,
                  }}
                >
                  Variant
                </p>{" "}
                <p
                  style={{
                    color: "#131A12",
                    fontSize: "16px",
                    fontWeight: "600",
                    margin: 0,
                  }}
                >
                  {data.sampleVariant}
                </p>
                <p
                  style={{
                    color: "#6C757D",
                    fontSize: "14px",
                    fontWeight: "500",
                    margin: 0,
                  }}
                >
                  Reported
                </p>{" "}
                <p
                  style={{
                    color: "#313CA8",
                    fontSize: "16px",
                    fontWeight: "600",
                    margin: 0,
                  }}
                >
                  {data.VariantReport}
                </p>
              </div>
              {/* <div
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  width: "50%",
                }}
              >
                <p
                  style={{
                    color: "#6C757D",
                    fontSize: "14px",
                    fontWeight: "500",
                    margin: 0,
                  }}
                >
                  Type
                </p>{" "}
                <p
                  style={{
                    color: "#131A12",
                    fontSize: "16px",
                    fontWeight: "600",
                    margin: 0,
                  }}
                >
                  type
                </p>
              </div> */}
            </div>
          </div>

          {/* Parameter Overview and Compliance Status Section */}
          <div style={{ display: "flex", gap: 24, marginBottom: 24 }}>
            {/* Parameter Overview Block */}
            <div
              style={{
                flex: 1,
                background: "#fff",
                borderRadius: 8,
                padding: 24,
                boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
              }}
            >
              <div>
                <p
                  style={{
                    color: "#131A12",
                    fontSize: "20px",
                    fontWeight: "600",
                    marginBottom: "8px",
                  }}
                >
                  Parameter Overview
                </p>
              </div>
              <div>
                <div
                  style={{
                    display: "flex",
                    gap: 16,
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 16,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "50%",
                    }}
                  >
                    <p
                      style={{
                        color: "#6C757D",
                        fontSize: "14px",
                        fontWeight: "500",
                        margin: 0,
                      }}
                    >
                      Total
                    </p>{" "}
                    <p
                      style={{
                        color: "#131A12",
                        fontSize: "16px",
                        fontWeight: "600",
                        margin: 0,
                      }}
                    >
                      {" "}
                      {data?.parametersOverview?.totalParameters}{" "}
                    </p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "50%",
                    }}
                  >
                    <p
                      style={{
                        color: "#6C757D",
                        fontSize: "14px",
                        fontWeight: "500",
                        margin: 0,
                      }}
                    >
                      Missing
                    </p>{" "}
                    <p
                      style={{
                        color: "#A52A2A",
                        fontSize: "16px",
                        fontWeight: "600",
                        margin: 0,
                      }}
                    >
                      {" "}
                      {data?.parametersOverview?.missingParameters}{" "}
                    </p>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: 16,
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "50%",
                    }}
                  >
                    <p
                      style={{
                        color: "#6C757D",
                        fontSize: "14px",
                        fontWeight: "500",
                        margin: 0,
                      }}
                    >
                      Matched
                    </p>{" "}
                    <p
                      style={{
                        color: "#4A7C59",
                        fontSize: "16px",
                        fontWeight: "600",
                        margin: 0,
                      }}
                    >
                      {" "}
                      {data?.parametersOverview?.matchedParameters}{" "}
                    </p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "50%",
                    }}
                  >
                    <p
                      style={{
                        color: "#6C757D",
                        fontSize: "14px",
                        fontWeight: "500",
                        margin: 0,
                      }}
                    >
                      Manually Matched
                    </p>{" "}
                    <p
                      style={{
                        color: "#4A7C59",
                        fontSize: "16px",
                        fontWeight: "600",
                        margin: 0,
                      }}
                    >
                      {data?.parametersOverview?.totalParameters -
                        (data?.parametersOverview?.notTestedParameters +
                          data?.parametersOverview?.matchedParameters +
                          data?.parametersOverview?.missingParameters)}
                    </p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "50%",
                    }}
                  >
                    <p
                      style={{
                        color: "#6C757D",
                        fontSize: "14px",
                        fontWeight: "500",
                        margin: 0,
                      }}
                    >
                      Not Tested
                    </p>{" "}
                    <p
                      style={{
                        color: "#DAA520",
                        fontSize: "16px",
                        fontWeight: "600",
                        margin: 0,
                      }}
                    >
                      {" "}
                      {data?.parametersOverview?.notTestedParameters}{" "}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* Compliance Status Block */}
            <div
              style={{
                flex: 1.3,
                background: "#fff",
                borderRadius: 8,
                padding: 24,
                boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
              }}
            >
              <div style={{ fontWeight: 600, marginBottom: 16 }}>
                <p
                  style={{
                    color: "#131A12",
                    fontSize: "20px",
                    fontWeight: "600",
                    marginBottom: "8px",
                  }}
                >
                  Compliance Status
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  gap: 16,
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 16,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "33%",
                  }}
                >
                  <p
                    style={{
                      color: "#6C757D",
                      fontSize: "14px",
                      fontWeight: "500",
                      margin: 0,
                    }}
                  >
                    Overall
                  </p>{" "}
                  <p
                    style={{
                      color: "#131A12",
                      fontSize: "16px",
                      fontWeight: "600",
                      margin: 0,
                    }}
                  >
                    {" "}
                    {
                      data?.sampleComplianceDetails?.overallSampleClassification
                    }{" "}
                  </p>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "33%",
                  }}
                >
                  <p
                    style={{
                      color: "#6C757D",
                      fontSize: "14px",
                      fontWeight: "500",
                      margin: 0,
                    }}
                  >
                    Safety
                  </p>{" "}
                  <p
                    style={{
                      color: "#131A12",
                      fontSize: "16px",
                      fontWeight: "600",
                      margin: 0,
                    }}
                  >
                    {" "}
                    {data?.sampleComplianceDetails?.overallSafetyCompliant}{" "}
                  </p>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "33%",
                  }}
                >
                  <p
                    style={{
                      color: "#6C757D",
                      fontSize: "14px",
                      fontWeight: "500",
                      margin: 0,
                    }}
                  >
                    Quality
                  </p>{" "}
                  <p
                    style={{
                      color: "#131A12",
                      fontSize: "16px",
                      fontWeight: "600",
                      margin: 0,
                    }}
                  >
                    {" "}
                    {
                      data?.sampleComplianceDetails?.overallQualityCompliant
                    }{" "}
                  </p>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  gap: 16,
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "33%",
                  }}
                >
                  <p
                    style={{
                      color: "#6C757D",
                      fontSize: "14px",
                      fontWeight: "500",
                      margin: 0,
                    }}
                  >
                    Safe
                  </p>{" "}
                  <p
                    style={{
                      color: "#4A7C59",
                      fontSize: "16px",
                      fontWeight: "600",
                      margin: 0,
                    }}
                  >
                    {" "}
                    {data?.sampleComplianceDetails?.safeCount}{" "}
                  </p>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "33%",
                  }}
                >
                  <p
                    style={{
                      color: "#6C757D",
                      fontSize: "14px",
                      fontWeight: "500",
                      margin: 0,
                    }}
                  >
                    Unsafe
                  </p>{" "}
                  <p
                    style={{
                      color: "#A52A2A",
                      fontSize: "16px",
                      fontWeight: "600",
                      margin: 0,
                    }}
                  >
                    {" "}
                    {data?.sampleComplianceDetails?.unsafeCount}{" "}
                  </p>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "33%",
                  }}
                >
                  <p
                    style={{
                      color: "#6C757D",
                      fontSize: "14px",
                      fontWeight: "500",
                      margin: 0,
                    }}
                  >
                    Standard
                  </p>{" "}
                  <p
                    style={{
                      color: "#4A7C59",
                      fontSize: "16px",
                      fontWeight: "600",
                      margin: 0,
                    }}
                  >
                    {data?.sampleComplianceDetails?.standardCount}{" "}
                  </p>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "33%",
                  }}
                >
                  <p
                    style={{
                      color: "#6C757D",
                      fontSize: "14px",
                      fontWeight: "500",
                      margin: 0,
                    }}
                  >
                    Sub-Standard
                  </p>{" "}
                  <p
                    style={{
                      color: "#DAA520",
                      fontSize: "16px",
                      fontWeight: "600",
                      margin: 0,
                    }}
                  >
                    {" "}
                    {data?.sampleComplianceDetails?.subStandardCount}{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="review-report-container">
            <div
              className={showPdf ? "table-container" : ""}
              style={showPdf ? { width: "50%" } : { width: "100%" }}
            >
              <Table
                columns={columns}
                dataSource={tableData}
                rowKey="id"
                onChange={handleTablePagination}
                onRow={(record, index) => {
                  const isChanged = changedData.hasOwnProperty(record?.id);
                  const isUnsafe = record.compliance === "Unsafe";
                  const isSubStandard = record.compliance === "Sub-Standard";

                  const disableHover = isChanged || isUnsafe || isSubStandard;

                  return {
                    className: disableHover ? "no-hover" : "",
                    style: {
                      backgroundColor: isChanged
                        ? "rgb(255, 204, 0, .2)"
                        : isUnsafe
                        ? "rgba(255, 0, 0, .3)"
                        : isSubStandard
                        ? "rgba(255, 98, 0, .3)"
                        : "#fff",
                    },
                  };
                }}
                pagination={{
                  current: currentPage,
                  pageSize: pageSize,
                  total: data.pagination_details?.total_items,
                  showSizeChanger: true,
                  disabled: !data.pagination_details?.total_items,
                }}
              />
            </div>
            {showPdf && (
              <div style={{ width: "50%" }}>
                <embed
                  className="pdf-container"
                  src={reportUrl}
                  type="application/pdf"
                />
              </div>
            )}
          </div>
        </>
      ) : (
        <div style={{ textAlign: "center", marginTop: "50px" }}>
          <p style={{ fontSize: "18px", fontWeight: "bold" }}>
            Report is not parsed for this order.
          </p>
          <p style={{ fontSize: "16px", color: "#6c757d" }}>
            Please contact support for assistance.
          </p>
        </div>
      )}
      {/* Action confirmation modal  */}
      <Modal
        title={"Confirmation"}
        visible={isActionModalVisible}
        centered
        onCancel={() => {
          setIsActionModalVisible(false);
          setActionType("");
          setActionData({});
          setUnSaveAction("");
        }}
        bodyStyle={{ borderRadius: 8, padding: 32, minHeight: 130 }}
        style={{ borderRadius: 8, overflow: "hidden", minWidth: 400 }}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              setIsActionModalVisible(false);
              setActionType("");
              setActionData({});
              setUnSaveAction("");
            }}
            style={{ minWidth: 80 }}
          >
            No
          </Button>,
          <Button
            key="confirm"
            type="primary"
            style={{ minWidth: 80 }}
            loading={isConfirmLoading}
            onClick={() => {
              setIsConfirmLoading(true);
              if (
                Object.keys(changedData).length > 0 &&
                unSaveAction === "save"
              ) {
                handleSave();
              } else {
                handleConfirmAction();
              }
            }}
          >
            Yes
          </Button>,
        ]}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: 18,
            color: "#333",
            fontWeight: 500,
          }}
        >
          <Text>
            {`Are you sure you want to `}
            <span
              style={{
                color: actionType === "notTested" ? "#FAAD14" : "#ED2100",
              }}
            >
              {actionType === "notTested"
                ? "Mark As Not Tested?"
                : "Remove Mapping?"}
            </span>
          </Text>
        </div>

        {Object.keys(changedData).length > 0 && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              color: "#333",
              gap: 16,
              marginTop: 16,
            }}
          >
            <Text>There are some unsaved changes in the report.</Text>
            <Radio.Group
              onChange={(e) => setUnSaveAction(e.target.value)}
              style={{ display: "flex", gap: 12 }}
              value={unSaveAction}
            >
              <Radio value="discard">Discard Changes</Radio>
              <Radio value="save">Save & Re-Evaluate</Radio>
            </Radio.Group>
          </div>
        )}
      </Modal>
      {openRaiseCorrectionModal && (
        <RaiseCorrectionRequest
          id={_id}
          orderId={data.orderId}
          onOpen={openRaiseCorrectionModal}
          onClose={() => setOpenRaiseCorrectionModal(false)}
          fetchUpdatedData={getReportdata}
        />
      )}
      {openViewCorrectionModal && (
        <ViewCorrection
          id={_id}
          orderId={data.orderId}
          onOpen={openViewCorrectionModal}
          onClose={() => setOpenViewCorrectionModal(false)}
        />
      )}
    </div>
  );
}

const statusColorMap = {
  ProcessingFailed: "red",
  Processing: "cyan",
  ReviewInProgress: "orange",
  ReviewPending: "blue",
  ReviewCompleted: "green",
  "Under Dispute": "red",
  // Add more statuses as needed
};
